import axios from 'axios';

export const AUTHENTICATE_URL = `${process.env.REACT_APP_API_URL}/Authenticate`;

export const changePassword = (password: string, newPassword: string, confirmPassword: string) => {
  return axios.post(`${AUTHENTICATE_URL}/change-password`, { password, newPassword, confirmPassword });
};